

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import LineGraph from '../components/analysis/LineGraph.vue';
import ScatterGraph from '../components/analysis/ScatterGraph.vue';
import { StatisticalAnalysisSingleRecordComparison } from '../interfaces/StatisticalAnalysisSingleRecordComparison';
import { StatisticalAnalysisRecord } from '../interfaces/StatisticalAnalysisRecord';
import { eventBus, eventBusEvents } from '../helpers/eventBusHelper';
import { HighlightItemType } from '../enums/HighlightItemType';
import { ProductReport } from '@/interfaces/ProductReport';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';
import { SingleFolderInterface } from '@/interfaces/SingleFolderInterface';

@Component({
    name: 'StatisticalAnalysis',
    components: {
        LineGraph,
        ScatterGraph,
    },
})
export default class StatisticalAnalysis extends Vue {
    protected get isTrademark() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Trademark
        );
    }

    protected get isCustomer() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.CustomerRelations
        );
    }

    protected get isGoodwill() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Goodwill
        );
    }

    protected get isTechnology() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Technology
        );
    }

    protected get isSoftware() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Software
        );
    }

    protected get getUsefulInfo() {
        if (this.isTrademark) {
            const usefulInfo = [
                {
                    name: 'Trademarks with indefinite lifetime',
                    value: this.currentStatisticalAnalysis.meta.lifetime
                        .indefinite,
                    percentage: this.calcAvg(
                        this.currentStatisticalAnalysis.meta.lifetime
                            .indefinite,
                    ),
                },
                {
                    name: 'Trademarks with definite lifetime',
                    value: this.currentStatisticalAnalysis.meta.lifetime
                        .definite,
                    percentage: this.calcAvg(
                        this.currentStatisticalAnalysis.meta.lifetime.definite,
                    ),
                },
                {
                    name: 'Avg definite lifetime (years)',
                    value: this.currentStatisticalAnalysis.meta.lifetime.avgLifetime.toFixed(
                        1,
                    ),
                },
            ];
            return usefulInfo;
        } else if (this.isTechnology) {
            const usefulInfo = [
                {
                    name: 'Technology with indefinite lifetime',
                    value: this.currentStatisticalAnalysis.meta.lifetime
                        .indefinite,
                    percentage: this.calcAvg(
                        this.currentStatisticalAnalysis.meta.lifetime
                            .indefinite,
                    ),
                },
                {
                    name: 'Technology with definite lifetime',
                    value: this.currentStatisticalAnalysis.meta.lifetime
                        .definite,
                    percentage: this.calcAvg(
                        this.currentStatisticalAnalysis.meta.lifetime.definite,
                    ),
                },
                {
                    name: 'Avg definite lifetime (years)',
                    value: this.currentStatisticalAnalysis.meta.lifetime.avgLifetime.toFixed(
                        1,
                    ),
                },
            ];
            return usefulInfo;
        } else {
            const usefulInfo = [
                {
                    name: 'Software with indefinite lifetime',
                    value: this.currentStatisticalAnalysis.meta.lifetime
                        .indefinite,
                    percentage: this.calcAvg(
                        this.currentStatisticalAnalysis.meta.lifetime
                            .indefinite,
                    ),
                },
                {
                    name: 'Software with definite lifetime',
                    value: this.currentStatisticalAnalysis.meta.lifetime
                        .definite,
                    percentage: this.calcAvg(
                        this.currentStatisticalAnalysis.meta.lifetime.definite,
                    ),
                },
                {
                    name: 'Avg definite lifetime (years)',
                    value: this.currentStatisticalAnalysis.meta.lifetime.avgLifetime.toFixed(
                        1,
                    ),
                },
            ];
            return usefulInfo;
        }
    }

    protected get activeProject() {
        return this.$store.getters['projects/activeProject'];
    }

    protected get lineGraphs() {
        this.changeCounter++;

        if (this.isTrademark) {
            const graphsTrademark = [
                {
                    chartCaption: 'Royalty rate avg',
                    yAxisName: 'royalty rate',
                    xAxisName: null,
                    type: 'line',
                    lineColor: '#44355b',
                    data: this.getLineGraphData('royaltyRateAverage'),
                    key: this.changeCounter,
                    trendLines: [
                        {
                            displayValue: '25% quartile',
                            // @ts-ignore
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[3]
                                    .royaltyRateAverage * 100,
                        },
                        {
                            displayValue: '75% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[5]
                                    .royaltyRateAverage * 100,
                        },
                    ],
                },
                {
                    chartCaption: 'Brand profit split',
                    yAxisName: 'brand value / EV',
                    xAxisName: null,
                    type: 'line',
                    lineColor: '#ee9669',
                    data: this.getLineGraphData('trademarkPerEV'),
                    key: this.changeCounter,
                    trendLines: [
                        {
                            displayValue: '25% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[3]
                                    .brandEV * 100,
                        },
                        {
                            displayValue: '75% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[5]
                                    .brandEV * 100,
                        },
                    ],
                },
            ];
            return graphsTrademark;
        }

        if (this.isCustomer) {
            const graphsCustomer = [
                {
                    chartCaption: 'Customer margin avg',
                    yAxisName: 'customer margin',
                    xAxisName: null,
                    type: 'line',
                    lineColor: '#44355b',
                    data: this.getLineGraphData('implCustMargAvg'),
                    key: this.changeCounter,
                    trendLines: [
                        {
                            displayValue: '25% quartile',
                            // @ts-ignore
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[3]
                                    .custAvg * 100,
                        },
                        {
                            displayValue: '75% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[5]
                                    .custAvg * 100,
                        },
                    ],
                },
                {
                    chartCaption: 'Customer profit split',
                    yAxisName: 'customer value / EV',
                    xAxisName: null,
                    type: 'line',
                    lineColor: '#ee9669',
                    data: this.getLineGraphData('customerRelationPerEV'),
                    key: this.changeCounter,
                    trendLines: [
                        {
                            displayValue: '25% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[3]
                                    .custEV * 100,
                        },
                        {
                            displayValue: '75% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[5]
                                    .custEV * 100,
                        },
                    ],
                },
            ];

            return graphsCustomer;
        }
        if (this.isGoodwill) {
            const graphsGoodwill = [
                {
                    chartCaption: 'Goodwill margin avg',
                    yAxisName: 'goodwill margin',
                    xAxisName: null,
                    type: 'line',
                    lineColor: '#44355b',
                    data: this.getLineGraphData('implGwMargAvg'),
                    key: this.changeCounter,
                    trendLines: [
                        {
                            displayValue: '25% quartile',
                            // @ts-ignore
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[3]
                                    .gwMarginAvg * 100,
                        },
                        {
                            displayValue: '75% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[5]
                                    .gwMarginAvg * 100,
                        },
                    ],
                },
                {
                    chartCaption: 'Goodwill profit split',
                    yAxisName: 'goodwill / EV',
                    xAxisName: null,
                    type: 'line',
                    lineColor: '#ee9669',
                    data: this.getLineGraphData('goodwillPerEV'),
                    key: this.changeCounter,
                    trendLines: [
                        {
                            displayValue: '25% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[3]
                                    .goodwillEV * 100,
                        },
                        {
                            displayValue: '75% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[5]
                                    .goodwillEV * 100,
                        },
                    ],
                },
                {
                    chartCaption: 'Goodwill per staff member',
                    yAxisName: 'goodwill / staff (1,000$)',
                    xAxisName: null,
                    type: 'line',
                    suffix: '$',
                    lineColor: '#9ac995',
                    data: this.getLineGraphData('gwPerStaffThUsd', 'number'),
                    key: this.changeCounter,
                    trendLines: [
                        {
                            displayValue: '25% quartile',
                            startValue: this.currentStatisticalAnalysis.meta
                                .stats[3].gwPerStaffThUsd,
                        },
                        {
                            displayValue: '75% quartile',
                            startValue: this.currentStatisticalAnalysis.meta
                                .stats[5].gwPerStaffThUsd,
                        },
                    ],
                },
            ];

            return graphsGoodwill;
        }

        if (this.isTechnology) {
            const graphsTechnology = [
                {
                    chartCaption: 'Royalty rate avg',
                    yAxisName: 'royalty rate',
                    xAxisName: null,
                    type: 'line',
                    lineColor: '#44355b',
                    data: this.getLineGraphData(
                        this.highlightedItems.sustained
                            ? 'implTechMargAvgNoObs'
                            : 'implTechMargAvgObs',
                    ),
                    key: this.changeCounter,
                    trendLines: [
                        {
                            displayValue: '25% quartile',
                            // @ts-ignore
                            startValue: this.highlightedItems.sustained
                                ? this.currentStatisticalAnalysis.meta.stats[3]
                                      .techMarginAvgNoObs * 100
                                : this.currentStatisticalAnalysis.meta.stats[3]
                                      .techMarginAvgObs * 100,
                        },
                        {
                            displayValue: '75% quartile',
                            startValue: this.highlightedItems.sustained
                                ? this.currentStatisticalAnalysis.meta.stats[5]
                                      .techMarginAvgNoObs * 100
                                : this.currentStatisticalAnalysis.meta.stats[5]
                                      .techMarginAvgObs * 100,
                        },
                    ],
                },
                {
                    chartCaption: 'Technology profit split',
                    yAxisName: 'technology value / EV',
                    xAxisName: null,
                    type: 'line',
                    lineColor: '#ee9669',
                    data: this.getLineGraphData('techPerEV'),
                    key: this.changeCounter,
                    trendLines: [
                        {
                            displayValue: '25% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[3]
                                    .techEV * 100,
                        },
                        {
                            displayValue: '75% quartile',
                            startValue:
                                this.currentStatisticalAnalysis.meta.stats[5]
                                    .techEV * 100,
                        },
                    ],
                },
            ];

            return graphsTechnology;
        }
        const graphsSoftware = [
            {
                chartCaption: 'Royalty rate avg',
                yAxisName: 'royalty rate',
                xAxisName: null,
                type: 'line',
                lineColor: '#44355b',
                data: this.getLineGraphData(
                    this.highlightedItems.sustained
                        ? 'implSwMargAvgNoObs'
                        : 'implSwMargAvgObs',
                ),
                key: this.changeCounter,
                trendLines: [
                    {
                        displayValue: '25% quartile',
                        // @ts-ignore
                        startValue: this.highlightedItems.sustained
                            ? this.currentStatisticalAnalysis.meta.stats[3]
                                  .swMarginAvgNoObs * 100
                            : this.currentStatisticalAnalysis.meta.stats[3]
                                  .swMarginAvgObs * 100,
                    },
                    {
                        displayValue: '75% quartile',
                        startValue: this.highlightedItems.sustained
                            ? this.currentStatisticalAnalysis.meta.stats[5]
                                  .swMarginAvgNoObs * 100
                            : this.currentStatisticalAnalysis.meta.stats[5]
                                  .swMarginAvgObs * 100,
                    },
                ],
            },
            {
                chartCaption: 'Software profit split',
                yAxisName: 'software value / EV',
                xAxisName: null,
                type: 'line',
                lineColor: '#ee9669',
                data: this.getLineGraphData('swPerEV'),
                key: this.changeCounter,
                trendLines: [
                    {
                        displayValue: '25% quartile',
                        startValue:
                            this.currentStatisticalAnalysis.meta.stats[3].swEV *
                            100,
                    },
                    {
                        displayValue: '75% quartile',
                        startValue:
                            this.currentStatisticalAnalysis.meta.stats[5].swEV *
                            100,
                    },
                ],
            },
        ];

        return graphsSoftware;
    }

    protected get scatterGraphs() {
        if (this.isTrademark) {
            const graphsTrademark = [
                {
                    chartCaption: 'Royalty rate / profit split',
                    yAxisName: 'royalty rate',
                    xAxisName: 'brand value / EV',
                    type: 'profitSplit',
                    lineColor: '#894b70',
                    data: this.getScatterGraphData(
                        'trademarkPerEV',
                        'royaltyRateAverage',
                    ),
                    key: this.changeCounter,
                },
                {
                    chartCaption: 'Royalty rate / profitability',
                    yAxisName: 'royalty rate',
                    xAxisName: 'sales multiple (EV/rev)',
                    type: 'profitability',
                    lineColor: '#de7d6d',
                    data: this.getScatterGraphData(
                        'enterpriseValuePerRevenue',
                        'royaltyRateAverage',
                    ),
                    key: this.changeCounter,
                },
            ];

            return graphsTrademark;
        }

        if (this.isCustomer) {
            const graphsCustomer = [
                {
                    chartCaption: 'Customer margin / profit split',
                    yAxisName: 'customer margin',
                    xAxisName: 'cust value / EV',
                    type: 'profitSplit',
                    lineColor: '#894b70',
                    data: this.getScatterGraphData(
                        'customerRelationPerEV',
                        'implCustMargAvg',
                    ),
                    key: this.changeCounter,
                },
                {
                    chartCaption: 'Customer margin/ profitability',
                    yAxisName: 'customer margin',
                    xAxisName: 'sales multiple (EV/rev)',
                    type: 'profitability',
                    lineColor: '#de7d6d',
                    data: this.getScatterGraphData(
                        'enterpriseValuePerRevenue',
                        'implCustMargAvg',
                    ),
                    key: this.changeCounter,
                },
            ];

            return graphsCustomer;
        }
        if (this.isGoodwill) {
            const graphGoodwill = [
                {
                    chartCaption: 'Goodwill margin / profitability',
                    yAxisName: 'goodwill margin',
                    xAxisName: 'sales multiple (EV/rev)',
                    type: 'profitability',
                    lineColor: '#44355b',
                    data: this.getScatterGraphData(
                        'enterpriseValuePerRevenue',
                        'implGwMargAvg',
                    ),
                    key: this.changeCounter,
                },
                {
                    chartCaption: 'Goodwill split / profitability',
                    yAxisName: 'goodwill / EV',
                    xAxisName: 'sales multiple (EV/rev)',
                    type: 'profitability',
                    lineColor: '#ee9669',
                    data: this.getScatterGraphData(
                        'enterpriseValuePerRevenue',
                        'goodwillPerEV',
                    ),
                    key: this.changeCounter,
                },
                {
                    chartCaption: 'Goodwill / profitability',
                    yAxisName: 'goodwill / staff (1,000$)',
                    xAxisName: 'sales multiple (EV/rev)',
                    yNumberSuffix: '$',
                    type: 'profitability',
                    lineColor: '#9ac995',
                    data: this.getScatterGraphData(
                        'enterpriseValuePerRevenue',
                        'gwPerStaffThUsd',
                    ),
                    key: this.changeCounter,
                },
            ];

            return graphGoodwill;
        }
        if (this.isTechnology) {
            const graphsTechnology = [
                {
                    chartCaption: 'Royalty rate / profit split',
                    yAxisName: 'royalty rate',
                    xAxisName: 'technology value / EV',
                    type: 'profitSplit',
                    lineColor: '#894b70',
                    data: this.getScatterGraphData(
                        'techPerEV',
                        this.highlightedItems.sustained
                            ? 'implTechMargAvgNoObs'
                            : 'implTechMargAvgObs',
                    ),
                    key: this.changeCounter,
                },
                {
                    chartCaption: 'Royalty rate / profitability',
                    yAxisName: 'royalty rate',
                    xAxisName: 'sales multiple (EV/rev)',
                    type: 'profitability',
                    lineColor: '#de7d6d',
                    data: this.getScatterGraphData(
                        'enterpriseValuePerRevenue',
                        this.highlightedItems.sustained
                            ? 'implTechMargAvgNoObs'
                            : 'implTechMargAvgObs',
                    ),
                    key: this.changeCounter,
                },
            ];

            return graphsTechnology;
        }
        const graphsSoftware = [
            {
                chartCaption: 'Royalty rate / profit split',
                yAxisName: 'royalty rate',
                xAxisName: 'software value / EV',
                type: 'profitSplit',
                lineColor: '#894b70',
                data: this.getScatterGraphData(
                    'swPerEV',
                    this.highlightedItems.sustained
                        ? 'implSwMargAvgNoObs'
                        : 'implSwMargAvgObs',
                ),
                key: this.changeCounter,
            },
            {
                chartCaption: 'Royalty rate / profitability',
                yAxisName: 'royalty rate',
                xAxisName: 'sales multiple (EV/rev)',
                type: 'profitability',
                lineColor: '#de7d6d',
                data: this.getScatterGraphData(
                    'enterpriseValuePerRevenue',
                    this.highlightedItems.sustained
                        ? 'implSwMargAvgNoObs'
                        : 'implSwMargAvgObs',
                ),
                key: this.changeCounter,
            },
        ];

        return graphsSoftware;
    }

    protected get currentStatisticalAnalysis() {
        return this.$store.getters['user/currentStatisticalAnalysis'];
    }

    @Action('user/getCurrentStatisticalAnalysis')
    protected getCurrentStatisticalAnalysis!: (ids: string[]) => void;
    @Action('projects/downloadStatisticalAnalysisPDF')
    protected downloadStatisticalAnalysisPDF!: ({
        ids,
        projectName,
        revenueForecastType,
    }: {
        ids: string;
        projectName: string;
        revenueForecastType: string;
    }) => Promise<string>;
    @Action('projects/downloadStatisticalAnalysisExcel')
    protected downloadStatisticalAnalysisExcel!: ({
        ids,
        projectName,
        revenueForecastType,
    }: {
        ids: string;
        projectName: string;
        revenueForecastType: string;
    }) => Promise<string>;

    protected highlightedItems = {
        royalty: true,
        brand: false,
        goodwill: false,
        custMargin: true,
        custEV: false,
        goodwillMarginAvg: true,
        goodwillStaff: false,
        sustained: true,
        obsolescenceDeclining: false,
        techPerEV: false,
        swPerEV: false,
    };

    protected changeCounter = 0;
    @Action('projects/getSingleReport')
    private getSingleReport!: (id: number) => void;

    protected getLineGraphData(columnName: string, type = 'percentage') {
        const data: object[] = [];
        let y;
        this.currentStatisticalAnalysis.forEach(
            (element: any, index: string) => {
                if (element[columnName]) {
                    y = parseFloat(element[columnName].replace(',', '.'));
                    if (type === 'percentage') {
                        data.push({
                            label: String(index + 1),
                            value: parseFloat((y * 100).toFixed(4)),
                        });
                    } else {
                        data.push({
                            label: String(index + 1),
                            value: parseFloat(y.toFixed()),
                        });
                    }
                }
            },
        );
        return data.sort((a: any, b: any) => {
            return a.value - b.value;
        });
    }

    protected getScatterGraphData(firstParam: string, secondParam: string) {
        const data: object[] = [];
        this.currentStatisticalAnalysis.forEach(
            (element: any, index: string) => {
                if (element[firstParam]) {
                    let xValue = element[firstParam].replace(',', '.');
                    if (
                        firstParam === 'customerRelationPerEV' ||
                        firstParam === 'trademarkPerEV' ||
                        firstParam === 'techPerEV' ||
                        firstParam === 'swPerEV'
                    ) {
                        xValue = xValue * 100;
                    }
                    if (element[firstParam] && element[secondParam]) {
                        data.push({
                            x: xValue,
                            y:
                                secondParam === 'gwPerStaffThUsd'
                                    ? Number(
                                          element[secondParam].replace(
                                              ',',
                                              '.',
                                          ),
                                      ).toFixed()
                                    : element[secondParam].replace(',', '.') *
                                      100,
                        });
                    }
                }
            },
        );
        return data;
    }

    protected getRevInMillion(revenue: string | number) {
        if (revenue && !Number.isNaN(Number(revenue))) {
            let revenueNum = revenue;
            if (typeof revenue === 'string') {
                revenueNum = parseFloat(revenue.replace(',', '.'));
            }
            if (revenueNum < 0.046) {
                return '';
            } else if (revenueNum < 0.96) {
                const value = '$' + (revenueNum as number).toFixed(1);
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            } else {
                const value = '$' + Math.round(revenueNum as number);
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        } else {
            return '';
        }
    }

    protected parseAndRound(
        text: string,
        dec: number,
        suf?: string,
        shouldMultiply = true,
    ) {
        if (text !== '' && text) {
            if (parseFloat(text.replace(',', '.')) === 0) {
                return text + suf;
            }
            let numberValue = parseFloat(text.replace(',', '.'));
            if (shouldMultiply) {
                numberValue = numberValue * 100;
            }
            const value = numberValue.toFixed(dec);
            if (value !== '0.0') {
                return value + suf;
            }
            return numberValue.toFixed(2) + suf;
        } else {
            return '';
        }
    }

    protected roundNumber(num: number) {
        if (!isNaN(num)) {
            if (num === 0) {
                return '0' + '%';
            }
            const value = num * 100;
            if (value < 0.1) {
                return (num * 100).toFixed(2) + '%';
            } else {
                return (num * 100).toFixed(1) + '%';
            }
        } else {
            return '';
        }
    }

    protected calcAvg(first: number) {
        const result =
            (first /
                (this.currentStatisticalAnalysis.meta.lifetime.definite +
                    this.currentStatisticalAnalysis.meta.lifetime.indefinite)) *
            100;

        return result.toFixed(0) + '%';
    }

    protected rowClassHandler(rowData: {
        row: StatisticalAnalysisSingleRecordComparison;
        rowIndex: number;
    }) {
        return rowData.row.type === 'median' ? 'is-median' : '';
    }

    protected toggleHighlightedItems(itemType: HighlightItemType) {
        if (itemType === 'sustained') {
            this.highlightedItems['obsolescenceDeclining'] = !this
                .highlightedItems['obsolescenceDeclining'];
        }
        if (itemType === 'obsolescenceDeclining') {
            this.highlightedItems['sustained'] = !this.highlightedItems[
                'sustained'
            ];
        }
        this.highlightedItems[itemType] = !this.highlightedItems[itemType];
    }

    protected async removeRecordFromAnalysis(id: string) {
        if (this.currentStatisticalAnalysis.length > 2) {
            eventBus.$emit(eventBusEvents.activateGlobalLoading);
            const activeRecordIds = this.currentStatisticalAnalysis.map(
                (record: StatisticalAnalysisRecord) => record.id,
            );
            activeRecordIds.splice(activeRecordIds.indexOf(id), 1);
            await this.getCurrentStatisticalAnalysis(activeRecordIds);
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
        }
    }

    protected navigateToSingleFolder() {
        this.$router.push({ name: 'SingleFolder' });
    }

    protected sortRevenues(a: any, b: any) {
        return this.sortNumberValues(+a.usdRevenues, +b.usdRevenues);
    }

    protected sortGoodwill(a: any, b: any) {
        if (this.isGoodwill) {
            return this.sortNumberValues(
                +a.revPerStaffThUsd,
                +b.revPerStaffThUsd,
            );
        }

        return this.sortNumberValues(+a.goodwillPerEV, +b.goodwillPerEV);
    }

    protected sortBrandValue(a: any, b: any) {
        if (this.isTrademark) {
            return this.sortNumberValues(+a.usdBrandVal, +b.usdBrandVal);
        }
        if (this.isCustomer) {
            return this.sortNumberValues(+a.custValueUSD, +b.custValueUSD);
        }

        return this.sortNumberValues(+a.gwUsd, +b.gwUsd);
    }

    protected sortLifetime(a: any, b: any) {
        if (this.isTrademark) {
            return this.sortNumberValues(+a.usefulLifetime, +b.usefulLifetime);
        }
        if (this.isCustomer) {
            return this.sortNumberValues(+a.lifetimeCv, +b.lifetimeCv);
        }

        return this.sortNumberValues(+a.gwRev, +b.gwRev);
    }

    protected sortEVPerRev(a: any, b: any) {
        return this.sortNumberValues(
            +a.enterpriseValuePerRevenue,
            +b.enterpriseValuePerRevenue,
        );
    }

    protected sortBrandPerRev(a: any, b: any) {
        if (this.isTrademark) {
            return this.sortNumberValues(
                +a.trademarkPerRevenue,
                +b.trademarkPerRevenue,
            );
        }
        if (this.isCustomer) {
            return this.sortNumberValues(
                +a.custValueRevenue,
                +b.custValueRevenue,
            );
        }

        return this.sortNumberValues(+a.implGwMargAvg, +b.implGwMargAvg);
    }

    protected sortRoyaltyRateReported(a: any, b: any) {
        if (this.isCustomer) {
            return this.sortNumberValues(
                +a.implCustMargAvg,
                +b.implCustMargAvg,
            );
        }
        if (this.isGoodwill) {
            return this.sortNumberValues(+a.implGwMargOpt, +b.implGwMargOpt);
        }

        if (a.royaltyRateReported && b.royaltyRateReported) {
            return this.sortNumberValues(
                +a.royaltyRateReported,
                +b.royaltyRateReported,
            );
        }
        return this.sortNumberValues(
            +a.royaltyRateAverage,
            +b.royaltyRateAverage,
        );
    }

    protected sortRoyaltyRateLow(a: any, b: any) {
        if (this.isTrademark) {
            return this.sortNumberValues(+a.royaltyRateLow, +b.royaltyRateLow);
        }
        if (this.isCustomer) {
            return this.sortNumberValues(
                +a.implCustMargOpt,
                +b.implCustMargOpt,
            );
        }

        return this.sortNumberValues(+a.implGwMargCaut, +b.implGwMargCaut);
    }

    protected sortRoyaltyRateHigh(a: any, b: any) {
        if (this.isTrademark) {
            return this.sortNumberValues(
                +a.royaltyRateHigh,
                +b.royaltyRateHigh,
            );
        }
        if (this.isCustomer) {
            return this.sortNumberValues(
                +a.implCustMargCaut,
                +b.implCustMargCaut,
            );
        }

        return this.sortNumberValues(+a.goodwillPerEV, +b.goodwillPerEV);
    }

    protected sortBrandPerEV(a: any, b: any) {
        if (this.isTrademark) {
            return this.sortNumberValues(+a.trademarkPerEV, +b.trademarkPerEV);
        }
        if (this.isCustomer) {
            return this.sortNumberValues(
                +a.customerRelationPerEV,
                +b.customerRelationPerEV,
            );
        }

        return this.sortNumberValues(+a.gwPerStaffThUsd, +b.gwPerStaffThUsd);
    }

    protected sortNumberValues(a: number, b: number) {
        if (a === b) {
            return 0;
        } else if (a === null || isNaN(a)) {
            return 1;
        } else if (b === null || isNaN(b)) {
            return -1;
        }
        return a - b;
    }

    protected async openReportDetails(row: ProductReport) {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        const projectItem = this.activeProject.projectItems.filter(
            (activeProject: SingleFolderInterface) => {
                return activeProject.brand.id === row.id;
            },
        );
        if (!projectItem.length) {
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            return new Error('No such project item exists');
        }
        await this.getSingleReport(projectItem[0].id);
        this.$router.push({ name: 'SingleRecordDetails' }, () => {
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
        });
    }

    protected async onDownloadPDF() {
        this.$message.info('Generating statistical analysis, please wait.');
        const projectName = this.activeProject.name;
        const revenueForecastType = this.highlightedItems.sustained
            ? 'sustained'
            : 'obsolescenceDeclining';
        const ids = this.currentStatisticalAnalysis.map(
            (record: StatisticalAnalysisRecord) => record.id,
        );
        let statisticalAnalysis: string;
        try {
            statisticalAnalysis = await this.downloadStatisticalAnalysisPDF({
                ids: ids.join(','),
                projectName,
                revenueForecastType,
            });
        } catch (e) {
            this.$message.error('There has been an error, please try again.');
            return;
        }
        const blob = await this.decodePDF(statisticalAnalysis);
        let name = '';
        if (this.activeProject.prodGroup === 't') {
            name = `MARKABLES_Analysis_${this.activeProject.id}-tm.pdf`;
        } else if (this.activeProject.prodGroup === 'c') {
            name = `MARKABLES_Analysis_${this.activeProject.id}-cr.pdf`;
        } else if (this.activeProject.prodGroup === 'g') {
            name = `MARKABLES_Analysis_${this.activeProject.id}-gw.pdf`;
        } else if (this.activeProject.prodGroup === 'e') {
            name = `MARKABLES_Analysis_${this.activeProject.id}-tc.pdf`;
        } else {
            name = `MARKABLES_Analysis_${this.activeProject.id}-sw.pdf`;
        }

        this.fileSaver(blob, name);
    }

    protected async onDownloadCSV() {
        this.$message.info('Generating statistical analysis, please wait.');
        const projectName = this.activeProject.name;
        const revenueForecastType = this.highlightedItems.sustained
            ? 'sustained'
            : 'obsolescenceDeclining';
        const ids = this.currentStatisticalAnalysis.map(
            (record: StatisticalAnalysisRecord) => record.id,
        );
        let statisticalAnalysis: string;
        try {
            statisticalAnalysis = await this.downloadStatisticalAnalysisExcel({
                ids: ids.join(','),
                projectName,
                revenueForecastType,
            });
        } catch (e) {
            this.$message.error('There has been an error, please try again.');
            return;
        }
        const blob = await this.decodeCSV(statisticalAnalysis);
        let name = '';
        if (this.activeProject.prodGroup === 't') {
            name = `MARKABLES_Analysis_${this.activeProject.id}-tm.xlsx`;
        } else if (this.activeProject.prodGroup === 'c') {
            name = `MARKABLES_Analysis_${this.activeProject.id}-cr.xlsx`;
        } else if (this.activeProject.prodGroup === 'g') {
            name = `MARKABLES_Analysis_${this.activeProject.id}-gw.xlsx`;
        } else if (this.activeProject.prodGroup === 'e') {
            if (this.highlightedItems.sustained) {
                name = `MARKABLES_Analysis_${this.activeProject.id}-tcs.xlsx`;
            } else {
                name = `MARKABLES_Analysis_${this.activeProject.id}-tcd.xlsx`;
            }
        } else {
            if (this.highlightedItems.sustained) {
                name = `MARKABLES_Analysis_${this.activeProject.id}-sws.xlsx`;
            } else {
                name = `MARKABLES_Analysis_${this.activeProject.id}-swd.xlsx`;
            }
        }
        this.fileSaver(blob, name);
    }

    protected async decodePDF(invoice: string) {
        const byteCharacters = atob(invoice);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    }

    protected async decodeCSV(invoice: string) {
        const byteCharacters = atob(invoice);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'text/csv' });
    }

    protected fileSaver(blob: Blob, name: string) {
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, name);
            return;
        } else if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, name);
            return;
        }
        link.href = data;
        link.download = name;
        document.body.appendChild(link);
        link.click();
    }

    protected handleCommand(command: string) {
        if (command === 'pdf') {
            this.onDownloadPDF();
            return;
        }

        if (command === 'excel') {
            this.onDownloadCSV();
            return;
        }
        return;
    }

    protected getAppropriateValue(
        trademarkValue: string | number,
        customerValue: string | number,
        goodwillValue: string | number,
        technologyValue: string | number,
        softwareValue: string | number,
    ) {
        if (this.isTrademark) {
            return trademarkValue;
        }
        if (this.isCustomer) {
            return customerValue;
        }
        if (this.isGoodwill) {
            return goodwillValue;
        }
        if (this.isTechnology) {
            return technologyValue;
        }
        return softwareValue;
    }
}
